import { create } from "zustand";

type RepaymentRequest = {
  id: string;
  amount: number;
  status: string;
  employeeName: string;
  employeeEmail: string;
  createdAt: string | Date;
  attachment: string;
} | null;

interface HookProps {
  open: boolean;
  repaymentRequest: RepaymentRequest;
  onOpenChange: (open: boolean) => void;
  setRepaymentRequest: (repaymentRequest: RepaymentRequest) => void;
}

export const useViewModal = create<HookProps>()((set) => ({
  open: false,
  repaymentRequest: null,
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  setRepaymentRequest: (repaymentRequest) =>
    set(() => ({
      repaymentRequest,
    })),
}));
